
import React from 'react';
import styled from 'styled-components';

const TextNoWrap = styled.h6`
white-space: nowrap;
color: #0016FF;
font-weight: bold;
margin: 0 auto;
`;

export default ({ className, ...rest }) => <TextNoWrap className={className} {...rest} />;
